import { render, staticRenderFns } from "./ProjectsWorker.vue?vue&type=template&id=5b0de6ad"
import script from "./ProjectsWorker.vue?vue&type=script&lang=js"
export * from "./ProjectsWorker.vue?vue&type=script&lang=js"
import style0 from "./ProjectsWorker.vue?vue&type=style&index=0&id=5b0de6ad&prod&lang=scss"
import style1 from "./ProjectsWorker.vue?vue&type=style&index=1&id=5b0de6ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports